var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "listItem" }, [
    _c("div", { staticClass: "viewWrapper", on: { click: _vm.selectAlbum } }, [
      _vm.img
        ? _c("div", {
            staticClass: "imageNode privateData",
            style: _vm.styleObject,
            attrs: { "data-private": "" },
          })
        : _vm.error
        ? _c("div", { staticClass: "imageNode icon" }, [
            _c("i", { staticClass: "far fa-exclamation-triangle" }),
          ])
        : _c("div", { staticClass: "imageNode icon" }, [
            _c("i", { staticClass: "fa fa-spinner-third animationSpin" }),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "albumDetails" }, [
        _c("div", { staticClass: "albumName" }, [
          _vm._v("\n\t\t\t\t" + _vm._s(_vm.albumModel.name) + "\n\t\t\t"),
        ]),
        _vm._v(" "),
        _vm.albumModel.count > 0
          ? _c("div", { staticClass: "albumCount" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.albumModel.count) +
                  " " +
                  _vm._s(_vm.$t("photo", { count: 2 })) +
                  "\n\t\t\t"
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }